'use strict';

export const ASSET_FILE_ITEM_NAME = 'assetFileRequirement';
export const ASSET_FILE_ITEM_PREFIX = `@@${ASSET_FILE_ITEM_NAME}`;

export const PROJECT_FILE_ITEM_NAME = 'projectFileRequirement';
export const PROJECT_FILE_ITEM_PREFIX = `@@${PROJECT_FILE_ITEM_NAME}`;

export const ASSET_FORM_ITEM_NAME = 'assetFormRequirement';
export const ASSET_FORM_ITEM_PREFIX = `@@${ASSET_FORM_ITEM_NAME}`;

export const PROJECT_FORM_ITEM_NAME = 'projectFormRequirement';
export const PROJECT_FORM_ITEM_PREFIX = `@@${PROJECT_FORM_ITEM_NAME}`;

export const ASSET_LIST_NAME = 'assetRequirements';
export const ASSET_LIST_PREFIX = `@@${ASSET_LIST_NAME}`;

export const PROJECT_LIST_NAME = 'projectRequirements';
export const PROJECT_LIST_PREFIX = `@@${PROJECT_LIST_NAME}`;

export const TEMPLATE_LIST_NAME = 'templateRequirements';
export const TEMPLATE_LIST_PREFIX = `@@${TEMPLATE_LIST_NAME}`;

export const ASSET_FILES_LIST_NAME = 'assetRequirementFiles';
export const ASSET_FILES_LIST_PREFIX = `@@${ASSET_FILES_LIST_NAME}`;

export const PROJECT_FILES_LIST_NAME = 'projectRequirementsFiles';
export const PROJECT_FILES_LIST_PREFIX = `@@${PROJECT_FILES_LIST_NAME}`;

export const CREATE_ASSET_FILE_NAME = 'createAssetFileRequirement';
export const CREATE_ASSET_FILE_PREFIX = `@@${CREATE_ASSET_FILE_NAME}`;

export const CREATE_PROJECT_FILE_NAME = 'createProjectFileRequirement';
export const CREATE_PROJECT_FILE_PREFIX = `@@${CREATE_PROJECT_FILE_NAME}`;

export const CREATE_TEMPLATE_FILE_NAME = 'createTemplateFileRequirement';
export const CREATE_TEMPLATE_FILE_PREFIX = `@@${CREATE_TEMPLATE_FILE_NAME}`;

export const CREATE_ASSET_FORM_NAME = 'createAssetFormRequirement';
export const CREATE_ASSET_FORM_PREFIX = `@@${CREATE_ASSET_FORM_NAME}`;

export const CREATE_PROJECT_FORM_NAME = 'createProjectFormRequirement';
export const CREATE_PROJECT_FORM_PREFIX = `@@${CREATE_PROJECT_FORM_NAME}`;

export const CREATE_TEMPLATE_FORM_NAME = 'createTemplateFormRequirement';
export const CREATE_TEMPLATE_FORM_PREFIX = `@@${CREATE_TEMPLATE_FORM_NAME}`;

export const UPDATE_ASSET_FILE_NAME = 'updateAssetFileRequirement';
export const UPDATE_ASSET_FILE_PREFIX = `@@${UPDATE_ASSET_FILE_NAME}`;

export const UPDATE_PROJECT_FILE_NAME = 'updateProjectFileRequirement';
export const UPDATE_PROJECT_FILE_PREFIX = `@@${UPDATE_PROJECT_FILE_NAME}`;

export const UPDATE_TEMPLATE_FILE_NAME = 'updateTemplateFileRequirement';
export const UPDATE_TEMPLATE_FILE_PREFIX = `@@${UPDATE_TEMPLATE_FILE_NAME}`;

export const UPDATE_ASSET_FORM_NAME = 'updateAssetFormRequirement';
export const UPDATE_ASSET_FORM_PREFIX = `@@${UPDATE_ASSET_FORM_NAME}`;

export const UPDATE_PROJECT_FORM_NAME = 'updateProjectFormRequirement';
export const UPDATE_PROJECT_FORM_PREFIX = `@@${UPDATE_PROJECT_FORM_NAME}`;

export const UPDATE_TEMPLATE_FORM_NAME = 'updateTemplateFormRequirement';
export const UPDATE_TEMPLATE_FORM_PREFIX = `@@${UPDATE_TEMPLATE_FORM_NAME}`;

export const UPDATE_ASSET_FORM_RESPONSE_NAME = 'updateAssetFormReqResponse';
export const UPDATE_ASSET_FORM_RESPONSE_PREFIX = `@@${UPDATE_ASSET_FORM_RESPONSE_NAME}`;

export const UPDATE_PROJECT_FORM_RESPONSE_NAME = 'updateProjectFormReqResponse';
export const UPDATE_PROJECT_FORM_RESPONSE_PREFIX = `@@${UPDATE_PROJECT_FORM_RESPONSE_NAME}`;



// WEBPACK FOOTER //
// ./src/js/requirements/redux/state.js